import * as constants from './constants';

export function coursewareMetaInfoGetRequest(elementId, key) {
  return {
    type: constants.COURSEWARE_META_INFO_GET_REQUEST,
    elementId,
    key,
  };
}

export function coursewareMetaInfoGetSuccess(elementId, key, value) {
  return {
    type: constants.COURSEWARE_META_INFO_GET_SUCCESS,
    elementId,
    key,
    value,
  };
}

export function coursewareMetaInfoGetError(elementId, key) {
  return {
    type: constants.COURSEWARE_META_INFO_GET_ERROR,
    elementId,
    key,
  };
}

export function coursewareMetaInfoSetRequest(elementId, key, value) {
  return {
    type: constants.COURSEWARE_META_INFO_SET_REQUEST,
    elementId,
    key,
    value,
  };
}

export function coursewareMetaInfoSetSuccess(elementId, key, value) {
  return {
    type: constants.COURSEWARE_META_INFO_SET_SUCCESS,
    elementId,
    key,
    value,
  };
}

export function coursewareMetaInfoSetError(elementId, key) {
  return {
    type: constants.COURSEWARE_META_INFO_SET_ERROR,
    elementId,
    key,
  };
}
